import React, { useState } from 'react';
import { useAuth } from '../../lib/auth/AuthContext';
import { createCheckoutSession } from '../../lib/billing/createCheckoutSession';
import { Button } from '../ui/Button';

type Props = {
  label?: string;
  variant?: 'primary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  className?: string;
  /** Defaults to billing success / explore cancel */
  successUrl?: string;
  cancelUrl?: string;
};

export const SubscribeButton: React.FC<Props> = ({
  label = 'Subscribe',
  variant = 'primary',
  size = 'sm',
  fullWidth,
  className,
  successUrl,
  cancelUrl
}) => {
  const { session } = useAuth();
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleClick = async () => {
    setError(null);
    const token = session?.access_token;
    if (!token) {
      setError('Sign in to subscribe.');
      return;
    }
    const origin = window.location.origin;
    const success = successUrl ?? `${origin}/app/billing?checkout=success`;
    const cancel = cancelUrl ?? `${origin}/app/explore?checkout=cancel`;
    setPending(true);
    try {
      const { url } = await createCheckoutSession({
        accessToken: token,
        successUrl: success,
        cancelUrl: cancel
      });
      window.location.assign(url);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Could not start checkout.');
    } finally {
      setPending(false);
    }
  };

  return (
    <div className={fullWidth ? 'w-full' : undefined}>
      <Button
        type="button"
        variant={variant}
        size={size}
        fullWidth={fullWidth}
        className={className}
        disabled={pending}
        onClick={() => void handleClick()}
      >
        {pending ? 'Redirecting…' : label}
      </Button>
      {error ? (
        <p className="mt-1.5 text-xs text-danger" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
};
